import React from "react";
import Components from "mpm-components";
import { Form } from "semantic-ui-react";

export default ({ cessionExport, entities, pays }) => {
    return (
      <Components.Regions.RegionWithHeader
        title="menu.demande.export.transport-data"
        headerColor="blue"
        headerSize="small"
      >
        <Form>
          <Form.Group widths="equal">
            <Form.Select
              required
              label="Pays d'exportation"
              options={pays.data}
              disabled
              loading={pays.loading}
              error={pays.error}
              value={cessionExport.id_RefPaysExp}
            />
            <Form.Input
              label="Numéro cértificat vétérinaire"
              disabled
              value={cessionExport.numeroCertificatVeterinaire}
            />
            <Form.Input
              label="Nom Importateur "
              disabled
              value={cessionExport.nomImportateur}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
            required
              label="Port / Aéroport / Autre Lieu de départ"
              disabled
              value={cessionExport.lieuDepart}
            />
            <Form.Input
              label="Numéro Vol / Numéro lettre transport"
              disabled
              value={cessionExport.numeroVol}
            />
            <Form.Input
              label="Numéro lettre de voiture ferroviaire"
              disabled
              value={cessionExport.numeroVoitureFerro}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              label="Autres documents"
              disabled
              value={cessionExport.autreDocs}
            />
            <Form.Input
              label="Numéro du(des) conteneur(s)"
              disabled
              value={cessionExport.numeroConteneur}
            />
            <Form.Field />
          </Form.Group>
        </Form>
      </Components.Regions.RegionWithHeader>
    );
  };